import { Component } from '@angular/core';
import { SpThemingService } from '../../../services/sp-theming/sp-theming.service';
import { ImageType } from '../sp-page-error/sp-page-error.component';

@Component({
  selector: 'app-sp-page-shared-expired',
  templateUrl: './sp-page-shared-expired.component.html'
})
export class SpPageSharedExpiredComponent {
  protected readonly ImageType = ImageType;

  constructor(private _spTheming: SpThemingService) {
    this._spTheming.setSpThemeName('dashboard-default');
  }
}
